var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button, ButtonPriority, ButtonSize } from '../../Button';
import { TextButton, TextButtonPriority } from '../../TextButton';
import { SECTION_NOTIFICATION_DATA_HOOKS } from '../dataHooks';
import { classes as parentClasses } from '../SectionNotification.st.css';
import { SectionNotificationType, SectionNotificationButtonType, } from '../types';
import { st, classes } from './SectionNotificationButton.st.css';
import { SectionNotificationConsumer } from '../SectionNotificationContext';
var SectionNotificationButton = /** @class */ (function (_super) {
    __extends(SectionNotificationButton, _super);
    function SectionNotificationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textButtonDefaultProps = {
            priority: TextButtonPriority.primary,
        };
        _this.buttonDefaultProps = {
            priority: ButtonPriority.basic,
            size: ButtonSize.tiny,
        };
        return _this;
    }
    SectionNotificationButton.prototype.render = function () {
        var _a = this.props, children = _a.children, type = _a.type, buttonProps = __rest(_a, ["children", "type"]);
        var ButtonComponent = type === SectionNotificationButtonType.text ? TextButton : Button;
        var defaultButtonProps = type === SectionNotificationButtonType.text
            ? this.textButtonDefaultProps
            : this.buttonDefaultProps;
        return (React.createElement(SectionNotificationConsumer, null, function (_a) {
            var notificationType = _a.type;
            return (React.createElement("div", { className: st(classes.root, {
                    type: type,
                    wired: notificationType === SectionNotificationType.wired,
                }, parentClasses.button), "data-hook": SECTION_NOTIFICATION_DATA_HOOKS.button },
                React.createElement(ButtonComponent, __assign({ className: st(classes.button, {
                        priority: buttonProps.priority || defaultButtonProps.priority,
                    }) }, defaultButtonProps, buttonProps), children)));
        }));
    };
    SectionNotificationButton.displayName = 'SectionNotification.Button';
    SectionNotificationButton.defaultProps = {
        type: SectionNotificationButtonType.default,
    };
    return SectionNotificationButton;
}(React.Component));
export { SectionNotificationButton };
//# sourceMappingURL=SectionNotificationButton.js.map